import { useId } from 'react';

interface AgentAvatarProps {
  agentType: string;
  size?: number;
}

function getRingColor(agentType: string): string {
  const t = agentType.toLowerCase();
  if (t.includes('pm') || t.includes('requirement')) return '#10B981';
  if (t.includes('arch')) return '#EC4899';
  return '#A78BFA';
}

export default function AgentAvatar({ agentType, size = 32 }: AgentAvatarProps) {
  const uid = useId();
  const gradientId = `ag-${uid.replace(/:/g, '')}`;
  const ringColor = getRingColor(agentType);

  if (size < 24) {
    return (
      <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <defs>
          <linearGradient id={gradientId} x1="0" y1="0" x2="32" y2="32" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#7C3AED" />
            <stop offset="100%" stopColor="#5B21B6" />
          </linearGradient>
        </defs>
        <circle cx="16" cy="16" r="15" fill={`url(#${gradientId})`} stroke={ringColor} strokeWidth="2" />
        <circle cx="16" cy="16" r="4" fill="white" opacity="0.85" />
        <circle cx="25" cy="7" r="4" fill={ringColor} />
      </svg>
    );
  }

  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="32" y2="32" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#7C3AED" />
          <stop offset="100%" stopColor="#5B21B6" />
        </linearGradient>
      </defs>
      <circle cx="16" cy="16" r="15" fill={`url(#${gradientId})`} stroke={ringColor} strokeWidth="2" />
      {/* Simplified ascending layers */}
      <path d="M8 20 L16 16 L24 20 L16 24 Z" fill="white" opacity="0.3" />
      <path d="M8 17 L16 13 L24 17 L16 21 Z" fill="white" opacity="0.55" />
      <path d="M8 14 L16 10 L24 14 L16 18 Z" fill="white" opacity="0.85" />
    </svg>
  );
}
